
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copyright-registration",
      function () {
        return require("private-next-pages/copyright-registration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copyright-registration"])
      });
    }
  